import type { MetaDescriptor } from "react-router";

export function title(title: string): MetaDescriptor[] {
  const fullTitle = `${title} - Palmetto Homeschool Association`;

  return [{ title: fullTitle }];
}
